import { z } from "zod";
const TextBlockSchema = z.object({
    id: z.string(),
    type: z.literal("text"),
    text: z.string(),
});
const ImgBlockSchema = z.object({
    id: z.string(),
    type: z.literal("img"),
    src: z.string(),
    width: z.string().optional(),
});
const VideoBlockSchema = z.object({
    id: z.string(),
    type: z.literal("video"),
    src: z.string(),
    autoplay: z.boolean().optional(),
    loop: z.boolean().optional(),
});
export const BlockSchema = z.discriminatedUnion("type", [TextBlockSchema, ImgBlockSchema, VideoBlockSchema]);
export function getAssetUrls(blocks) {
    if (!blocks)
        return [];
    const mediaUrls = [];
    for (const block of blocks) {
        if (block.type === "text")
            continue;
        switch (block.type) {
            case "img":
                mediaUrls.push({ src: block.src, type: "image" });
                break;
            case "video":
                mediaUrls.push({ src: block.src, type: "video" });
                break;
        }
    }
    return mediaUrls;
}
